import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


/**
 * Creates and appends a dynamic manifest link based on the app name
 */
function appendCustomManifest(): void {
  const manifest = document.createElement('link');

  manifest.setAttribute('rel', 'manifest');
  manifest.setAttribute('href', `manifest_${environment.appName}.webmanifest`);
  document.head.appendChild(manifest);
}// ();


/**
 * Enables production mode and appends the custom manifest to the document head
 */
function configureProductionMode(): void {
  enableProdMode();
  appendCustomManifest();
}

/**
 * Destroys the previous app instance if it exists (useful for HMR or reboots)
 */
function destroyPreviousAppInstance(): void {
  if (window.ngRef !== null && window.ngRef !== undefined) {
    window.ngRef.destroy();
  }
}

/**
 * Bootstraps the Angular application and stores a global reference
 */
function bootstrapAngularApp(): void {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then(ref => {
      destroyPreviousAppInstance();
      window.ngRef = ref;
    })
    .catch(err => {
      console.error('💥 Error initializing Angular application', err);
    });
}

// Entry point
if (environment.production) {
  configureProductionMode();
}

bootstrapAngularApp();


// Extend the global Window interface to include ngRef
declare global {
  interface Window {
    ngRef?: any;
  }
}